import { axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { CustomAxiosResponse } from '@/api/AxiosResponse';
import { DEFAULT_DAY, POLYGON_AMOY, POLYGON_MAIN } from '@/lib/common/name-space';
import { snakeToCamelCase } from '@/lib/convert-code-style';
import { now } from '@/lib/dayjs';
import { ShortenAddr, ShortenTxId } from '@/lib/Shorten';
import {
  ReadAdminDashboardRewardType,
  ReadAdminDashboardStakeType,
  ReadAdminDashboardType,
  ReadAdminDashboardUnstakeType,
  ResUserDashboardType,
} from '@/types';

export const readFactoryList = async (aAddress?: string) => {
  const payload = {
    path: '/staking-factory/list',
    body: {},
  };
  return sendRequest(payload, 'readFactoryList', axiosPost);
};

export const readFactoryContractList = async () => {
  const payload = {
    path: '/staking-factory/find-contract',
    body: {},
  };
  return sendRequest(payload, 'readFactoryContractList', axiosPost);
};

export const readUserDashboardList = async (
  aPayload: ReadAdminDashboardType,
): Promise<CustomAxiosResponse<ResUserDashboardType>> => {
  const payload = {
    path: '/admin-dashboard/user-list',
    body: { ...aPayload },
  };
  const re = await sendRequest(payload, 'readUserDashboardList', axiosPost);
  if (re.status !== 200) {
    return re;
  }
  // 스테이킹
  const stake: ReadAdminDashboardStakeType[] = re.data?.stake
    ? re.data.stake.map((item: any, index: number) => ({
        ...snakeToCamelCase(item),
        shortAddress: ShortenAddr(item.address),
        shortTxHash: ShortenTxId(item.hash),
        index: index, // index를 추가하여 각 항목에 포함
        startDt: now(item.start_dt, DEFAULT_DAY),
        endDt: now(item.end_dt, DEFAULT_DAY),
      }))
    : [];
  // 언스테이킹
  const unstake: ReadAdminDashboardUnstakeType[] = re.data?.unstake
    ? re.data.unstake.map((item: any, index: number) => ({
        ...snakeToCamelCase(item),
        shortAddress: ShortenAddr(item.address),
        shortTxHash: ShortenTxId(item.hash),
        index: index, // index를 추가하여 각 항목에 포함
        startDt: now(item.start_dt, DEFAULT_DAY),
        endDt: now(item.end_dt, DEFAULT_DAY),
      }))
    : [];
  // 리워드
  const reward: ReadAdminDashboardRewardType[] = re.data?.reward
    ? re.data.reward.map((item: any, index: number) => ({
        ...snakeToCamelCase(item),
        shortAddress: ShortenAddr(item.address),
        shortTxHash: ShortenTxId(item.reward_hash),
        index: index, // index를 추가하여 각 항목에 포함
        startDt: now(item.start_dt, DEFAULT_DAY),
        endDt: now(item.end_dt, DEFAULT_DAY),
      }))
    : [];
  const withdraw = re.data?.withdraw
    ? re.data.withdraw.map((item: any, index: number) => ({
        ...snakeToCamelCase(item),
        shortAddress: ShortenAddr(item.address),
        shortTxHash: ShortenTxId(item.hash),
        index: index,
        startDt: now(item.start_dt, DEFAULT_DAY),
        endDt: now(item.end_dt, DEFAULT_DAY),
      }))
    : [];

  re.data = {
    stake,
    unstake,
    reward,
    withdraw,
  };
  return re;
};
